<template>
  <div class="inline-block">
    <svg
      viewBox="0 0 24 24"
      :width="`${size}px`"
      :height="`${size}px`"
      :class="rotate ? '-rotate-90' : ''"
      class="fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path :d="path" />
    </svg>
  </div>
</template>

<script lang="ts" setup>
export interface Props {
  path: string
  rotate?: boolean
  size?: number
}

withDefaults(defineProps<Props>(), {
  rotate: false,
  size: 16,
})
</script>
